// removed by extract-text-webpack-plugin
module.exports = {"featuredImg":"aQFpM0vrmXNWunbRgDoV3","content":"_1SpiHONfA53WPF6igCIWt1","placeholder":"_1I4tjHbAcRXtLbAFu_eSVO","featuredStoryLabel":"_1akNeiYhpf8ydK2NQjdN8A","postTitle":"_1eFl_IKb4t5iMAgHjFFB9b","postExtract":"_3P1cGn7mrur08j81bd_GXa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/blog-featured-post/BlogFeaturedPost.css
// module id = 403
// module chunks = 0